import { render, staticRenderFns } from "./pensionEspece.vue?vue&type=template&id=782251e9"
import script from "./pensionEspece.vue?vue&type=script&lang=js"
export * from "./pensionEspece.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports